module.exports = __webpack_public_path__ + "static/media/yggdrasil.8a676909.svg";